module.exports = __webpack_public_path__ + "static/media/monument_hero.fc39cc21.png";